import { Path, Transforms } from 'slate'

import { CustomEditor } from 'core-components/library/richTextEditor/interface/custom-types'

import { getCol, getGridTable, getStartCell, isTable, TableCol } from './commonTableHelper'

export const removeRow = (editor: CustomEditor) => {
  if (!editor.selection || !isTable(editor)) return
  const [, path] = getStartCell(editor)
  Transforms.removeNodes(editor, {
    at: Path.parent(path),
  })
}

export const removeCol = (editor: CustomEditor) => {
  if (!editor.selection || !isTable(editor)) return
  const { gridTable } = getGridTable(editor)
  const startCell = getStartCell(editor)
  const delCol = getCol(gridTable, (c: TableCol) => {
    return c.originPath[2] === startCell[1][2] && c.isReal
  })
  try {
    delCol.forEach((col) => {
      Transforms.removeNodes(editor, {
        at: col.originPath,
      })
    })
  } catch (e) {
    console.log(e)
  }
}
